(() => {
  'use strict';

  const PRICE_CONTAINER_SELECTOR = '.price__discount-pricing';
  const PROTECTED_PRICE_SELECTOR = '.tpo_ignore';
  const EASIFY_SELECTOR = '.easify-product-options';
  const EASIFY_PROPERTY_INPUT_SELECTOR = 'input[name^="properties["]';
  const EASIFY_SELECTED_CHOICE_SELECTOR = '.po-radioGroup-inputRadio:checked';
  let lastClickedChoiceFeeCents = 0;

  const parseCents = (value) => {
    const normalized = String(value || '')
      .replace(/[^0-9,.-]/g, '')
      .replace(/,/g, '');
    const amount = Number.parseFloat(normalized);

    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  };

  const formatCents = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
  };

  const getChoiceFeeCents = (choice) => {
    const choicePrice = choice?.querySelector('.po-optionItemLabel-price')?.textContent;
    const feeMatch = choicePrice?.match(/\$([\d,]+(?:\.\d{1,2})?)/);
    return feeMatch ? parseCents(feeMatch[1]) : 0;
  };

  const getToggleFeeCents = (toggle) => {
    const toggleText = toggle?.closest('.po-field-root')?.textContent;
    const feeMatch = toggleText?.match(/\$([\d,]+(?:\.\d{1,2})?)/);
    return feeMatch ? parseCents(feeMatch[1]) : 0;
  };

  const isColorMatchEnabled = () => {
    const colorMatchField = [...document.querySelectorAll(`${EASIFY_SELECTOR} .po-field-root`)]
      .find((field) => /color match/i.test(field.querySelector('.po-label-label')?.textContent || ''));

    if (!colorMatchField) return true;
    return colorMatchField.querySelector('.po-toggle-root')?.classList.contains('po-toggle-on') || false;
  };

  const getSelectedEasifyFeeCents = () => {
    if (!isColorMatchEnabled()) return 0;

    const propertyFees = [...document.querySelectorAll(`${EASIFY_SELECTOR} ${EASIFY_PROPERTY_INPUT_SELECTOR}`)]
      .reduce((total, input) => {
        const feeMatch = input.value.match(/\(\s*\$([\d,]+(?:\.\d{1,2})?)\s*\)/);
        return total + (feeMatch ? parseCents(feeMatch[1]) : 0);
      }, 0);

    const selectedChoiceFees = [...document.querySelectorAll(`${EASIFY_SELECTOR} ${EASIFY_SELECTED_CHOICE_SELECTOR}`)]
      .reduce((total, input) => {
        return total + getChoiceFeeCents(input.closest('.po-radioGroup-item'));
      }, 0);

    return propertyFees || selectedChoiceFees || lastClickedChoiceFeeCents;
  };

  const updateCustomPrices = (feeCents = getSelectedEasifyFeeCents()) => {

    document.querySelectorAll(PRICE_CONTAINER_SELECTOR).forEach((container) => {
      container.querySelectorAll(PROTECTED_PRICE_SELECTOR).forEach((priceElement) => {
        if (!priceElement.dataset.ez4x4BaseCents) {
          const baseCents = parseCents(priceElement.textContent);
          priceElement.dataset.ez4x4BaseCents = String(baseCents);
        }

        const baseCents = Number.parseInt(priceElement.dataset.ez4x4BaseCents, 10);
        if (!Number.isFinite(baseCents)) return;

        priceElement.textContent = formatCents(baseCents + feeCents);
      });
    });
  };

  const start = () => {
    let refreshTimer;
    const isEasifyInteraction = (event) => {
      return event.target instanceof Element && Boolean(event.target.closest(EASIFY_SELECTOR));
    };

    const handleEasifyInteraction = (event) => {
      if (!isEasifyInteraction(event)) return;

      const clickedChoice = event.target.closest('.po-radioGroup-item');
      if (clickedChoice) lastClickedChoiceFeeCents = getChoiceFeeCents(clickedChoice);

      const clickedToggle = event.target.closest('.po-toggle-root');
      if (clickedToggle) {
        const toggleFeeCents = getToggleFeeCents(clickedToggle);
        const isTurningOn = !clickedToggle.classList.contains('po-toggle-on');

        if (toggleFeeCents > 0) updateCustomPrices(isTurningOn ? toggleFeeCents : 0);
      }

      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => {
        if (clickedToggle && !isColorMatchEnabled()) lastClickedChoiceFeeCents = 0;
        updateCustomPrices();
      }, 35);
    };

    document.addEventListener('click', (event) => {
      handleEasifyInteraction(event);
    }, true);

    document.addEventListener('change', (event) => {
      handleEasifyInteraction(event);
    });

    updateCustomPrices();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
